// skipcq: JS-W1028, JS-0128
import React from 'react';
import PropTypes from 'prop-types';
import BeerDupesSection from '../../components/beer/BeerDupesSection';

/**
 * BreweryBeerDupesSection
 * Beer duplicate reviews scoped to a single brewery.
 */
function BreweryBeerDupesSection({ parentBreweryId }) {
  return (
    <BeerDupesSection breweryId={parentBreweryId} globalScope={false} />
  );
}

BreweryBeerDupesSection.propTypes = {
  parentBreweryId: PropTypes.string.isRequired,
};

export default BreweryBeerDupesSection;
